import { render, staticRenderFns } from "./TopBtn.vue?vue&type=template&id=30e92084&scoped=true"
import script from "./TopBtn.vue?vue&type=script&lang=js"
export * from "./TopBtn.vue?vue&type=script&lang=js"
import style0 from "./TopBtn.vue?vue&type=style&index=0&id=30e92084&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e92084",
  null
  
)

export default component.exports